import { Box, Button, Inline, L88 } from "@adfenix/alexandria";
import { useEffect, useState } from "react";
import { Visible, useScreenClass } from "react-grid-system";
import { useProSidebar } from "react-pro-sidebar";
import { RealforceLogo } from "static/svg/realforce-logo";
import styled from "styled-components";
import OpenMenuIcon from "./icons/OpenMenuIcon";

const PageHeaderContainer = styled(Box)<{ dark: boolean }>`
  position: fixed;
  transition: top 0.3s ${({ theme }) => theme.bezierCurve};
  width: 100%;
  z-index: 100;
  background: ${({ theme }) => theme.colors.white};

  border-bottom: 1px solid
    ${({ theme, dark }) => (dark ? "#050B1F" : L88(theme.colors.grey))};

  background-color: ${({ dark }) => (dark ? "#050B1F" : "white")};

  color: ${({ dark }) => (dark ? "#A1AAC7" : "#405163")};
`;

const StyledButton = styled(Button)`
  padding: 0;
  margin-left: 4px;
  line-height: 0;
`;

export const MobileHeader = () => {
  const screenClass = useScreenClass();
  const prevScrollPosition = window.scrollY;
  const { toggleSidebar, toggled } = useProSidebar();

  const [scrollPosition, setScrollPosition] = useState({
    prevScrollPosition,
    visible: true
  });
  const mobileView = ["xs", "sm"].includes(screenClass);

  const handleScroll = () => {
    const currentScrollPosition = window.scrollY;
    const visible =
      prevScrollPosition > currentScrollPosition || currentScrollPosition === 0;

    setScrollPosition({
      prevScrollPosition: currentScrollPosition,
      visible
    });
  };

  useEffect(() => {
    if (mobileView) window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  return (
    <Visible xs sm>
      <PageHeaderContainer
        dark
        p="s"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        style={{
          top: scrollPosition.visible ? "0px" : "-120px"
        }}
      >
        <Inline style={{ alignItems: "center" }}>
          <RealforceLogo />
        </Inline>

        {!toggled && (
          <StyledButton
            logLabel="open-menu-button"
            variant="secondaryText"
            onClick={() => toggleSidebar(true)}
          >
            <OpenMenuIcon darkTheme />
          </StyledButton>
        )}
      </PageHeaderContainer>
    </Visible>
  );
};
